export * from './decorators/lazy.js';
